import Swiper, {Navigation} from 'swiper';
// import {initFlatCardOptions} from '@/common/scripts/common';

const similarSliders = [...document.querySelectorAll('.j-slider-similar')];

similarSliders.forEach((slider) => {
    return new Swiper(slider, {
        modules         : [Navigation],
        wrapperClass    : 'j-slider-similar__wrapper',
        slideClass      : 'j-slider-similar__slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 'auto',
        navigation      : {
            prevEl       : '.j-slider-similar__arr-prev',
            nextEl       : '.j-slider-similar__arr-next',
            disabledClass: 'is-disabled'
        }
    });
});

// initFlatCardOptions();
